/**
 * Unisex Size Picker
 *
 * Handles the US Mens / US Womens tab switching for products tagged "unisexsize".
 * Reads Women's equivalent sizes from a brand-level metaobject (unisex_size_map)
 * injected into the variant-picker JSON as `sizeMap` (Men's value -> Women's value).
 *
 * Radio button values always remain as Men's sizes (Shopify variant resolution).
 * Only the visible label text changes between tabs.
 */

(function () {
    'use strict';
  
    function initUnisexSizePicker() {
      var variantPicker = document.querySelector('variant-picker[data-is-unisex="true"]');
      if (!variantPicker) return;
  
      var dataEl = variantPicker.querySelector('[type="application/json"]');
      if (!dataEl) return;
  
      var data = JSON.parse(dataEl.textContent);
      var sizeMap = data.sizeMap || {};
  
      var tabs = variantPicker.querySelectorAll('[data-unisex-tab]');
      var sizeSelector = variantPicker.querySelector('.option-selector[data-option="Size"]');
      if (!sizeSelector || tabs.length === 0) return;
  
      var sizeLabels = sizeSelector.querySelectorAll('.js-value');
  
      function stripSizePrefix(val) {
        return val ? val.replace(/^US\s*/i, '') : val;
      }
  
      var defaultTab = variantPicker.dataset.unisexDefault || 'womens';
  
      enableFormProperties();
      if (defaultTab === 'mens') {
        applyMensLabels();
      } else {
        applyWomensLabels();
      }
  
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
  
          if (tab.dataset.unisexTab === 'womens') {
            applyWomensLabels();
          } else {
            applyMensLabels();
          }
        });
      });
  
      variantPicker.addEventListener('on:variant:change', function (evt) {
        updateSizeProperty(evt.detail.variant);
      });
  
      var checkedInput = sizeSelector.querySelector('input[is-size-option]:checked');
      if (checkedInput) {
        var variants = data.variants || [];
        var initVariant = variants.find(function (v) { return v.id === getSelectedVariantId(); });
        updateSizeProperty(initVariant);
      }
  
      function getSizeOptionIndex() {
        var options = variantPicker.querySelectorAll('.option-selector');
        var idx = 0;
        options.forEach(function (sel, i) {
          if (sel.dataset.option === 'Size') idx = i;
        });
        return idx;
      }
  
      function applyWomensLabels() {
        sizeLabels.forEach(function (label) {
          var labelEl = label.closest('label');
          if (!labelEl) return;
          var input = sizeSelector.querySelector('input#' + labelEl.getAttribute('for'));
          if (!input) return;
  
          var rawVal = input.value;
          var lookupKey = stripSizePrefix(rawVal);
          var womensVal = sizeMap[lookupKey];
          if (womensVal) {
            label.textContent = 'US ' + womensVal;
          }
        });
      }
  
      function applyMensLabels() {
        sizeLabels.forEach(function (label) {
          var labelEl = label.closest('label');
          if (!labelEl) return;
          var input = sizeSelector.querySelector('input#' + labelEl.getAttribute('for'));
          if (!input) return;
          label.textContent = input.value;
        });
      }
  
      function enableFormProperties() {
        var section = variantPicker.closest('.js-product') || variantPicker.closest('.section-main-product');
        if (!section) return;
  
        var forms = section.querySelectorAll('.js-product-form');
        forms.forEach(function (form) {
          var sizeInput = form.querySelector('#unisex-size-display');
          var flagInput = form.querySelector('#unisex-flag');
          if (sizeInput) sizeInput.disabled = false;
          if (flagInput) flagInput.disabled = false;
        });
      }
  
      function getSelectedVariantId() {
        var section = variantPicker.closest('.js-product') || variantPicker.closest('.section-main-product');
        if (!section) return null;
        var idInput = section.querySelector('.js-product-form input[name="id"]');
        return idInput ? parseInt(idInput.value, 10) : null;
      }
  
      function updateSizeProperty(variant) {
        if (!variant) return;
  
        var sizeOptionIndex = getSizeOptionIndex();
        var rawMensVal = variant.options[sizeOptionIndex];
        var mensNum = stripSizePrefix(rawMensVal);
        var womensVal = sizeMap[mensNum] || '';
  
        var displayValue = '';
        if (womensVal) {
          displayValue = 'US M ' + mensNum + ' / W ' + womensVal;
        } else {
          displayValue = rawMensVal;
        }
  
        var section = variantPicker.closest('.js-product') || variantPicker.closest('.section-main-product');
        if (!section) return;
  
        var sizeInputs = section.querySelectorAll('#unisex-size-display');
        sizeInputs.forEach(function (input) {
          input.value = displayValue;
        });
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initUnisexSizePicker);
    } else {
      initUnisexSizePicker();
    }
  
    if (typeof customElements !== 'undefined') {
      customElements.whenDefined('variant-picker').then(function () {
        setTimeout(initUnisexSizePicker, 50);
      });
    }
  })();
  